import React from 'react';
import { Typography } from '@worthy-npm/worthy-common-ui-components';
import _ from 'lodash';
import { useAppSelector } from '../../app/hooks';
import { getShippingMethod } from '../../slices/schedulingSlice';

function ShippingOptionLabel() {
  const shippingMethod = useAppSelector(getShippingMethod);
  return (
    <>
      Shipping options -
      {' '}
      <Typography component="span" fontWeight="inherit" color="text.primary">
        FedEx
        {' '}
        {_.capitalize(shippingMethod)}
      </Typography>
    </>
  );
}

export default ShippingOptionLabel;
